import { Box, Stack, Text, Tooltip } from '@chakra-ui/react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useState } from 'react'

import theme from 'theme'

export type InputLabelProps = {
  text: string
  tooltipText?: string
}

const InputLabel = ({ text, tooltipText }: InputLabelProps) => {
  // state needed to allow mobile devices to trigger tooltip on "touch" events
  const [isTooltipOpen, setIsTooltipOpen] = useState(false)

  return (
    <Stack direction="row" align="center" spacing="4px" h="18px">
      <Text as="label" textStyle="label">
        {text}
      </Text>
      {tooltipText && (
        <Tooltip
          isOpen={isTooltipOpen}
          label={tooltipText}
          fontSize="sm"
          background={theme.baseColors.text.default}
          color={theme.colors.white}
          padding="8px"
          borderRadius="4px"
          arrowSize={12}
          hasArrow
        >
          <Box
            onMouseEnter={() => setIsTooltipOpen(true)}
            onMouseLeave={() => setIsTooltipOpen(false)}
            onClick={() => setIsTooltipOpen(true)}
          >
            <FontAwesomeIcon icon={['far', 'circle-info']} size="sm" color={theme.baseColors.info.main} />
          </Box>
        </Tooltip>
      )}
    </Stack>
  )
}

export default InputLabel
